<template>
  <el-aside :width="asideWidth" :style="{ 'max-width': asideMaxWidth }" class="flex flex-column space-between">
    <div>
      <AppNavigationMain />
      <AppNavigationCategories v-if="hasModuleW2P" class="m-t-half" :items="campaignCategories" />
      <AppNavigationConnect v-if="hasModuleBluebox" class="m-t-half" :items="connectItems" />
      <AppNavigationMedia class="m-t-half" :items="mediaCategories" />
    </div>

    <div>
      <AppNavigationSecondary class="b-b" />

      <div v-if="!menuIsCollapsed">
        <p class="font--small color-gray p-l-2 m-t-half m-b-half">Version {{ version }}</p>
      </div>
    </div>
  </el-aside>
</template>

<script>
import { mapGetters } from 'vuex';
import { ARTICLES, WIDGETS, CONNECT_SOCIAL_MEDIA } from '@/router/route-types';
import AppNavigationConnect from '@/components/App/AppNavigationConnect';
import AppNavigationCategories from '@/components/App/AppNavigationCategories';
import AppNavigationMain from '@/components/App/AppNavigationMain';
import AppNavigationMedia from '@/components/App/AppNavigationMedia';
import AppNavigationSecondary from '@/components/App/AppNavigationSecondary';

export default {
  name: 'AppAside',

  components: {
    AppNavigationConnect,
    AppNavigationCategories,
    AppNavigationMain,
    AppNavigationMedia,
    AppNavigationSecondary
  },

  computed: {
    ...mapGetters({
      asideMaxWidth: `aside/maxWidth`,
      asideWidth: `aside/width`,
      campaignCategories: `templates/CATEGORIES_CAMPAIGNS`,
      mediaCategories: `templates/CATEGORIES_MEDIA`,
      hasManuallyPublishedArticles: 'bb_widgets/hasManuallyPublishedArticles',
      hasModuleBluebox: `user/hasModuleBluebox`,
      hasModuleW2P: `user/hasModuleW2P`,
      menuIsCollapsed: `menu/isCollapsed`
    }),

    connectItems() {
      const items = [
        {
          name: 'widgets',
          title: this.$t('navBlueboxWidgets'),
          icon: 'extension',
          route: {
            name: WIDGETS
          }
        },
        {
          name: 'social-media',
          title: this.$t('navConnectSocialMedia'),
          icon: 'extension',
          route: {
            name: CONNECT_SOCIAL_MEDIA
          }
        }
      ];

      // Add 'Publish articles' item in navigation
      if (this.hasManuallyPublishedArticles) {
        items.push({
          name: 'articles',
          title: this.$t('Publish Articles'),
          icon: 'description',
          route: {
            name: ARTICLES
          }
        });
      }

      return items;
    },

    version() {
      return process.env.VUE_APP_VERSION;
    }
  }
};
</script>

<style lang="scss" scoped>
.el-aside {
  background-color: #ffffff;
  border-right: 1px solid $c-medium-gray;
  transition: all 0.3s ease-in-out;

  @media screen and (min-width: $screen-md) {
  }
}
</style>
